<div class="filter-item">
  <a mat-button class="primary-menu-button" [matMenuTriggerFor]="stateFilter">
    <span class="pr-2" [class.primary-color]="!allStatesSelected">{{ menuLabel }}</span>
    <mat-icon iconPositionEnd class="menu-expand-icon">arrow_drop_down</mat-icon>
  </a>

  <mat-menu #stateFilter="matMenu" (closed)="onMenuClosed($event)">
    <div>
      <div class="ml-3"><b>State</b></div>

      <button mat-menu-item (click)="$event.stopPropagation()">
        <mat-checkbox
          color="primary"
          class="primary-checkbox"
          [checked]="stateSelection.isEmpty()"
          (change)="toggleAllStates($event.checked)">
          All
        </mat-checkbox>
      </button>

      @for (s of states; track s.id) {
        <button mat-menu-item (click)="$event.stopPropagation()">
          <mat-checkbox
            color="primary"
            class="primary-checkbox"
            [checked]="isStateChecked(s)"
            (change)="toggleState(s)">
            {{ s.name }}
          </mat-checkbox>
        </button>
      }
    </div>

    <div class="flex-row space-between items-center px-2 py-2 sticky">
      <a color="primary" mat-button (click)="onClearClick()">Clear</a>
      <button mat-flat-button color="primary" mat-button (click)="onApplyClick()">Apply</button>
    </div>
  </mat-menu>
</div>